import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductReveal } from './components/ProductReveal';
import { MechanismSection } from './components/MechanismSection';
import { HairTypeTest } from './components/HairTypeTest';
import { TransformationSection } from './components/TransformationSection';
import { AudienceSection } from './components/AudienceSection';
import { DeliverableSection } from './components/DeliverableSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <main className="w-full min-h-screen bg-cream-50 overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <ProductReveal data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <HairTypeTest data-id="element-6" />
      <TransformationSection data-id="element-7" />
      <AudienceSection data-id="element-8" />
      <DeliverableSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}